import axios from "axios";
import { CONTEST_API_ENDPOINT } from "@/setup/constants";

const contestApi = axios.create({
  baseURL: CONTEST_API_ENDPOINT
});

export default contestApi;
